import InputUnit from "./index.vue";

InputUnit.install = Vue => Vue.component(InputUnit.componentName, InputUnit);

export default InputUnit;
